import classes from './Checkbox.module.scss';

const Checkbox = ({ className, id, checked, onClick, type = 'standard', name, disabled = false, error }) => {
  const containerClasses = [classes.container];
  className && containerClasses.push(className);

  const nameInput = name || 'input-check';

  return (
    <label className={containerClasses.join(' ')}>
      <input
        disabled={disabled}
        name={nameInput}
        type='checkbox'
        checked={checked}
        value={id}
        onChange={event => onClick(event.target.checked)}
      />
      <span
        name={nameInput}
        className={`${error ? classes.error : classes['not-error']} ${classes.checkmark} ${classes[`checkmark-${type}`]} ${
          classes[`check-${type}`]
        }`}></span>
    </label>
  );
};

export default Checkbox;
